export class AzureVaultConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "cmkKeyVaultTenantId",
            "baseName": "cmkKeyVaultTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "cmkAppRegistrationId",
            "baseName": "cmkAppRegistrationId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AzureVaultConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
